import { render, staticRenderFns } from "./ModalBadgeInfo.vue?vue&type=template&id=6ee2ad53&scoped=true"
import script from "./ModalBadgeInfo.vue?vue&type=script&lang=js"
export * from "./ModalBadgeInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalBadgeInfo.vue?vue&type=style&index=0&id=6ee2ad53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee2ad53",
  null
  
)

export default component.exports